module.exports = __webpack_public_path__ + "static/media/black.d298df52.webp";